import { ReactNode } from 'react';
import {
  MatchedItem,
  MatchedTitle,
  MatchedToWrapper,
  NoText,
  MatchedImage,
} from './MatchedItemWrapper.styles';

interface IMatchedItemText {
  item: {
    text: string;
    image?: string;
  };
}

export const MatchedItemText = ({ item }: IMatchedItemText) => {
  if (!item) {
    return <NoText>Empty</NoText>;
  }
  return (
    <MatchedItem>
      {item.image && <MatchedImage src={item.image} alt={item.text} />}
      {item.text}
    </MatchedItem>
  );
};

interface IMatchedItem {
  title: string;
  fields: {
    text: string;
    image?: string;
  }[];
  children: ReactNode;
}

export const MatchedItemWrapper = ({
  title,
  fields,
  children,
}: IMatchedItem) => {
  return (
    <>
      <MatchedTitle>{title}</MatchedTitle>
      <MatchedToWrapper>
        {fields.map((field, _idx) => {
          return (
            <MatchedItemText
              item={{
                text: field.text,
                image: field.image,
              }}
              key={_idx}
            />
          );
        })}
        {children}
      </MatchedToWrapper>
    </>
  );
};
